import { uniqueId } from "lodash-es";
import { useState } from "react";

export function useUniqueId(idPrefix?: string) {
	const [id] = useState<string>(() => uniqueId(idPrefix));
	return id;
}
